export const aggregationItemsTimeRange = 300;
